export default () => {
    const dataLayer = getShoptetDataLayer()
    const isSectionPage = dataLayer.pageType === 'section';
    const namePage = document.querySelector('.in-kola-na-zakazku-test')
    let data
    const customBikeMenu = document.querySelector('.custom-bike-menu ul')
    const customBikeList = document.querySelector('.custom-bike-list-container')


    if (isSectionPage && namePage) {
        console.log('kola na zakázku :: page')

        $.ajax({
            url: '../user/documents/data/kola-na-zakazku-test3.json',
            type: 'get',
            success: function (req) {
                data = req.item
                renderingData(data)
                $('.custom-bike-menu ul li:first-child a').addClass('active')
                hideElement()
                clickElement()
            }
        })

        const renderingData = (data) => {

            for (const element of data) {
                const item = element.items

                customBikeMenu.insertAdjacentHTML('afterbegin', `
                    <li data-id="select-${element.id}"><a href="#">${element.name}</a></li>
                `)

                customBikeList.insertAdjacentHTML('afterbegin', `
                    <div class="custom-bike-list" data-id="select-${element.id}">
                       
                    </div>
                `)

                if (item) {
                    const cstBikeList = document.querySelector('.custom-bike-list')
                    for (const customBikeItem of item) {
                        cstBikeList.insertAdjacentHTML('afterbegin', `
                    <div class="custom-bike-item">
                        <a href="${customBikeItem.link}" class="custom-bike-image">
                            <img src="${customBikeItem.image}" alt="">
                        </a>
                        <a href="#" class="custom-bike-title"> ${customBikeItem.title} </a>
                        <a href="#" class="custom-bike-description">${customBikeItem.description}</a>
                        <a href="#" class="custom-bike-detail-btn">
                        <img src="/user/documents/img/sipka.svg" alt=""> </a>
                    </div>
                `)
                    }
                }

            }


        }

        const hideElement = () => {
            const id = $('.custom-bike-menu ul li a.active').parent().data('id')
            $('.custom-bike-list[data-id='+ id +']').addClass('show-item')
        }

        const clickElement = () => {

            $('.custom-bike-menu ul li a').on('click', function (event) {
                event.preventDefault()
                $(this).addClass('active')

                const parent = $(this).parent()
                const parentId = parent.data('id')
                parent.siblings().find('a').removeClass('active')
                showActiveElement(parentId)
            })
        }

        const showActiveElement = (id) => {
            const activeList = $('.custom-bike-list[data-id='+ id +']')
            activeList.addClass('show-item')

            $('.custom-bike-list').not('.custom-bike-list[data-id='+ id +']').each(function () {
                $(this).removeClass('show-item')
            })
        }

    }
}